import { PageHeader, QueryState, AssistantConnections } from '@/components';
import { useQuery, useMutation } from '@/lib/useQuery';
import { usePlatformAdmin, usePlatformCan } from '../lib/access';

/**
 * Connected AI assistants (ADR 0003, D48). Every admin sees and ends their own;
 * with admins.manage they also see and end every other admin's. The API decides.
 */
export default function Assistants() {
  const me = usePlatformAdmin();
  const manage = usePlatformCan('admins.manage');
  const q = useQuery('platformConnections', manage ? { scope: 'all' } : {}, { select: (r) => r.data });
  const end = useMutation('platformConnectionDisconnect');
  const origin = typeof window !== 'undefined' ? window.location.origin : '';
  const disconnect = async (row) => {
    await end.run({ id: row.id });
    q.reload();
  };

  return (
    <div className="space-y-4">
      <PageHeader title="AI assistants" subtitle="Run the platform from Claude, ChatGPT or another assistant, as yourself and within your role." />
      <QueryState query={q}>
        {(rows) => (
          <>
            <AssistantConnections
              title="Your assistants"
              connectUrls={[{ label: 'Platform administration', url: `${origin}/api/mcp/platform` }]}
              rows={rows.filter((r) => r.person.id === me.id)}
              onDisconnect={disconnect}
              emptyText="You have not connected an assistant yet. Connections last up to 12 hours before you sign in again."
            />
            {manage ? (
              <AssistantConnections title="Other admins' assistants" rows={rows.filter((r) => r.person.id !== me.id)} showPerson onDisconnect={disconnect} emptyText="No other admin has connected an assistant." />
            ) : null}
          </>
        )}
      </QueryState>
    </div>
  );
}
